export const HOTEL_SELECTION_CONFIRM_REQUEST_LOCAL_STORAGE_KEY = (eventId: string) => `${eventId}_hotelSelectionCartConfirmRequest`;
